import React from 'react'

interface IContentUtilsContext {
  scrollToTop: () => void
}

interface IContentUtilsContextProvider {
  contentRef?: React.MutableRefObject<HTMLDivElement | null> | null
}

/*
  Context to add any helper methods or attributes to the app content
*/
export const ContentUtilsContext = React.createContext<IContentUtilsContext>({
  scrollToTop: () => {}
})

export const ContentUtilsContextProvider: React.FC<IContentUtilsContextProvider> = ({ children, contentRef }) => {
  const scrollToTop = () => {
    if (contentRef?.current) {
      contentRef.current.scrollTo(0, 0)
    }
  }

  const value = React.useMemo(() => {
    return {
      scrollToTop
    }
  }, [scrollToTop])

  return <ContentUtilsContext.Provider value={value}>{children}</ContentUtilsContext.Provider>
}
